module.exports = __webpack_public_path__ + "static/christian_sec2-a28f1511babc493f977193b4f23de005.png";